import React, { useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { KDialog, KLoader, KSelectMulti } from "@kyburz/kdesign-system";
import { Customer2 } from "../../../interfaces/ReduxInterface";

const useStyles = makeStyles(() => ({
  container: {
    minHeight: 300,
    position: "relative",
  },
  loader: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backdropFilter: "blur(2px)",
  },
}));

type AssignToCompanyDialogProps = {
  companies: Customer2[];
  showDialog: boolean;
  onClose: () => void;
  onApply: (companies: Customer2[]) => void;
  loading: boolean;
};

const AssignToCompanyDialog: React.FC<AssignToCompanyDialogProps> = ({
  showDialog = false,
  onClose = () => {},
  onApply = () => {},
  companies = [],
  loading = false,
}) => {
  const classes = useStyles();

  const values = useMemo(
    () => companies.map((company) => ({ name: company.name })),
    [companies],
  );

  const [selected, setSelected] = useState<Customer2[]>([]);

  const apply = () => onApply(selected);

  const onSelect = (selectedName: string) =>
    setSelected((prev) => {
      const foundCompany = companies.find(({ name }) => name === selectedName);

      if (foundCompany) {
        return [...prev, foundCompany];
      }
      return prev;
    });

  return (
    <KDialog
      size="xs"
      open={showDialog}
      primaryCTAText="Assign"
      primaryCTAColor="primary"
      secondaryCTAText="Cancel"
      primaryCTAonClick={apply}
      secondaryCTAonClick={onClose}
      disabled={loading || selected.length === 0}
      title="Assign template to company"
    >
      <div className={classes.container}>
        <KSelectMulti
          name="Company selector"
          onChange={(_, _1, { option }) => onSelect(option.name)}
          label="Companies"
          elements={values}
        />

        {loading && (
          <div className={classes.loader}>
            <KLoader height="100%" />
          </div>
        )}
      </div>
    </KDialog>
  );
};

export default AssignToCompanyDialog;
